import { render, staticRenderFns } from "./example.vue?vue&type=template&id=aad5f44e&"
import script from "./example.vue?vue&type=script&lang=js&"
export * from "./example.vue?vue&type=script&lang=js&"
import style0 from "./example.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports